import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/login/Login";

import DashboardPage from "./pages/dashboard/DashboardPage";

import UsersPage from "./pages/users/UserList";
import CreateUserPage from "./pages/users/CreateUserPage";
import EditUserPage from "./pages/users/EditUserPage";

import CompanyList from "./pages/company/CompanyList";
import CreateCompany from "./pages/company/CreateCompany";
import EditCompany from "./pages/company/EditCompany";

import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import RoleRoute from "./components/RoleRoute";

import CreateCustomer from "./pages/operation/customer/CreateCustomer";
import EditCustomer from "./pages/operation/customer/EditCustomer";
import CustomersPage from "./pages/operation/customer/CustomersPage";

import CreateServiceCall from "./pages/operation/servicecall/CreateServiceCall";
import ServiceCallsPage from "./pages/operation/servicecall/ServiceCallsPage";
import EditServiceCall from "./pages/operation/servicecall/EditServiceCall";
import ViewServiceCall from "./pages/operation/servicecall/ViewServiceCall";

import WeightTests from "./pages/operation/weighttest/WeightTests";
import CreateWeightTest from "./pages/operation/weighttest/CreateWeightTest";
import EditWeightTest from "./pages/operation/weighttest/EditWeightTest";
import ViewWeightTest from "./pages/operation/weighttest/ViewWeightTest";

import CreateRepairQuotation from "./pages/operation/repairquotation/CreateRepairQuotation";
import RepairQuotations from "./pages/operation/repairquotation/RepairQuotations";
import EditRepairQuotation from "./pages/operation/repairquotation/EditRepairQuotation";
import ViewRepairQuotation from "./pages/operation/repairquotation/ViewRepairQuotation";

import CalibrationCertificates from "./pages/operation/calibrationcertificate/CalibrationCertificates";
import CreateCalibrationCertificate from "./pages/operation/calibrationcertificate/CreateCalibrationCertificate";
import EditCalibrationCertificate from "./pages/operation/calibrationcertificate/EditCalibrationCertificate";
import ViewCalibrationCertificate from "./pages/operation/calibrationcertificate/ViewCalibrationCertificate";

import CreateScale from "./pages/operation/scale/CreateScale";
import EditScale from "./pages/operation/scale/EditScale";

import CustomerScalesPage from "./pages/operation/scale/scale/CustomerScalesPage";
import ReportsPage from "./pages/reports/ReportsPage";

import ProductPage from "./pages/website/products/ProductPage";
import ContactPage from "./pages/website/requests/ContactPage ";

import CalibrationReport from "./pages/operation/reports/CalibrationReport";
import WeightTestReport from "./pages/operation/reports/WeightTestReport";

import { Toaster } from "react-hot-toast";

const isAuthenticated = () => {
  return !!localStorage.getItem("token"); // or your auth logic
};

function App() {
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      {
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                isAuthenticated() ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />

            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />

            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <ReportsPage />
                </ProtectedRoute>
              }
            />

             <Route
              path="/reports/calibration-due"
              element={
                <ProtectedRoute>
                  <CalibrationReport />
                </ProtectedRoute>
              }
            />

              <Route
              path="/reports/weight-test-due"
              element={
                <ProtectedRoute>
                  <WeightTestReport />
                </ProtectedRoute>
              }
            />

            <Route
              path="/calibration-certificates/view/:id"
              element={
                <ProtectedRoute>
                  <ViewCalibrationCertificate />
                </ProtectedRoute>
              }
            />

            <Route
              path="/calibration-certificates/edit/:id"
              element={
                <ProtectedRoute>
                  <EditCalibrationCertificate />
                </ProtectedRoute>
              }
            />

            <Route
              path="/calibration-certificates/create"
              element={
                <ProtectedRoute>
                  <CreateCalibrationCertificate />
                </ProtectedRoute>
              }
            />

            <Route
              path="/calibration-certificates"
              element={
                <ProtectedRoute>
                  <CalibrationCertificates />
                </ProtectedRoute>
              }
            />

            <Route
              path="/repair-quotations/view/:id"
              element={
                <ProtectedRoute>
                  <ViewRepairQuotation />
                </ProtectedRoute>
              }
            />

            <Route
              path="/repair-quotations/edit/:id"
              element={
                <ProtectedRoute>
                  <EditRepairQuotation />
                </ProtectedRoute>
              }
            />

            <Route
              path="/repair-quotations/create"
              element={
                <ProtectedRoute>
                  <CreateRepairQuotation />
                </ProtectedRoute>
              }
            />

            <Route
              path="/repair-quotations"
              element={
                <ProtectedRoute>
                  <RepairQuotations />
                </ProtectedRoute>
              }
            />

            <Route
              path="/weight-test-reports/view/:id"
              element={
                <ProtectedRoute>
                  <ViewWeightTest />
                </ProtectedRoute>
              }
            />

            <Route
              path="/weight-test-reports/edit/:id"
              element={
                <ProtectedRoute>
                  <EditWeightTest />
                </ProtectedRoute>
              }
            />

            <Route
              path="/weight-test-reports/create"
              element={
                <ProtectedRoute>
                  <CreateWeightTest />
                </ProtectedRoute>
              }
            />

            <Route
              path="/weight-test-reports"
              element={
                <ProtectedRoute>
                  <WeightTests />
                </ProtectedRoute>
              }
            />

            <Route
              path="/customers/create"
              element={
                <ProtectedRoute>
                  <CreateCustomer />
                </ProtectedRoute>
              }
            />

            <Route
              path="/scales"
              element={
                <ProtectedRoute>
                  <CustomerScalesPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/scales/create"
              element={
                <ProtectedRoute>
                  <CreateScale />
                </ProtectedRoute>
              }
            />

            <Route
              path="/scales/edit/:id"
              element={
                <ProtectedRoute>
                  <EditScale />
                </ProtectedRoute>
              }
            />

            <Route
              path="/service-calls"
              element={
                <ProtectedRoute>
                  <ServiceCallsPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/service-calls/create"
              element={
                <ProtectedRoute>
                  <CreateServiceCall />
                </ProtectedRoute>
              }
            />

            <Route
              path="/service-calls/edit/:id"
              element={
                <ProtectedRoute>
                  <EditServiceCall />
                </ProtectedRoute>
              }
            />

            <Route
              path="/service-calls/view/:id"
              element={
                <ProtectedRoute>
                  <ViewServiceCall />
                </ProtectedRoute>
              }
            />

            <Route
              path="/customers/edit/:id"
              element={
                <ProtectedRoute>
                  <EditCustomer />
                </ProtectedRoute>
              }
            />

            <Route
              path="/customers/create"
              element={
                <ProtectedRoute>
                  <CreateCustomer />
                </ProtectedRoute>
              }
            />

            <Route
              path="/customers"
              element={
                <ProtectedRoute>
                  <CustomersPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/companies"
              element={
                <ProtectedRoute>
                  <RoleRoute allowedRoles={["Super Admin"]}>
                    <CompanyList />
                  </RoleRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/companies/create"
              element={
                <ProtectedRoute>
                  <RoleRoute allowedRoles={["Super Admin"]}>
                    <CreateCompany />
                  </RoleRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/companies/edit/:id"
              element={
                <ProtectedRoute>
                  <RoleRoute allowedRoles={["Super Admin"]}>
                    <EditCompany />
                  </RoleRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <RoleRoute allowedRoles={["Admin", "Super Admin"]}>
                    <UsersPage />
                  </RoleRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/users/create"
              element={
                <ProtectedRoute>
                  <RoleRoute allowedRoles={["Admin", "Super Admin"]}>
                    <CreateUserPage />
                  </RoleRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/users/edit/:id"
              element={
                <ProtectedRoute>
                  <RoleRoute allowedRoles={["Admin", "Super Admin"]}>
                    <EditUserPage />
                  </RoleRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/products"
              element={
                <ProtectedRoute>
                  <RoleRoute allowedRoles={["Admin", "Super Admin"]}>
                    <ProductPage />
                  </RoleRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/requests"
              element={
                <ProtectedRoute>
                  <ContactPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      }
    </>
  );
}

export default App;
